<template>
  <!--数据概览-->
  <div class="outer">
    <div class="line">
    <div class="ensure">
      <div></div>
      <span>保证水位</span>
    </div>
    <div class="alert"> 
      <div></div>
      <span>警戒水位</span>
    </div>
      <div class="ensure-line"></div>
      <div class="alert-line"></div>
    </div>
    
    <div class="waterL" ref="waterL" id="waterL"></div>
  </div>
</template>

<script>
//import { EleResize } from ".././assets/echartsto/esresize";
export default {
  name: "waterL",

  data() {
    return {
      value: 0,
    };
  },
  watch: {
    data() {},
  },
  mounted() {
    this.drawChart();
  },
  methods: {
    drawChart() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("waterL"));
      var echarts = require("echarts");
      // 指定图表的配置项和数据
      let option = {
        grid: {
          left: 10,
          top: 25,
          bottom: 2,
          right: 10,
          containLabel: true,
        },
        legend: {
          icon: "rect",
          show: true,
          width: 10,
          hieght: 10,
          left: 60,
          itemWidth: 20,
          itemHeight: 10,
          borderRadius: 0,
          textStyle: {
            fontSize: 12,
            color: "#c9ccce",
          },
        },
        xAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
          textStyle: {
            color: "#bdc1c2",
          },
          data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
          axisLabel: {
            color: "#bdc1c2",
          },
        },
        yAxis: {
          type: "value",
          name: "(m²)",
          nameGap: 10,
          min: 0,
          max: 14,
          axisLabel: {
            color: "#bdc1c2",
          },
          splitLine: {
            lineStyle: {
              color: "#464f58",
              type: [10, 10],
              dashOffset: 15,
            },
          },
          splitNumber:8,
          nameTextStyle: {
            color: "#e3e5e6",
          },
          axisLine: {
            show: true,
          },
        },
        series: [
          {
            data: [8, 2, 6, 5, 4, 6, 8, 2, 3, 5, 6, 3],

            type: "bar",
            name: "实时水位",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(
                0,
                0,
                0,
                1,
                [
                  {
                    offset: 0,
                    color: "rgb(0,121,254)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0,121,254,0)",
                  },
                ],
                false
              ),
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      window.addEventListener("resize", () => {
         myChart.resize();
      });
      // let listener = function () {
       
      // };
      //EleResize.on(this.$refs.waterL, listener);
    },
  },
};
</script>

<style scoped>
.outer {
  width:18vw;
  height: 19vh;
}
.waterL {
  width: 100%;
  height: 100%;
}
.line {
  width:18vw;
  height: 19vh;
 
  position: absolute;
}
.ensure {
  position: absolute;
  width:4.94vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: 7.78vw;
}
.ensure div {
  width:2vw;
  border-bottom:1px dashed #00fef4;
  margin-top: .5vh;
}
.ensure span {
  font-size:.6vw;
  color: #c9ccce;
}

.alert {
  position: absolute;
  width:4.94vw;
  display: flex;
  justify-content: space-between;
  align-items: center;
  left: 13vw;
}

.alert div {
  width:2vw;
  border-bottom:1px dashed #ffb801;
  margin-top: .5vh;
}

.alert span {
  font-size:.7vw;
  color: #c9ccce;
}
.ensure-line {
  width:15.9vw;
  border-bottom:1px dashed  #00fef4;
  position: absolute;
  left:1.75vw;
  top:7.6vh;
  z-index: 5;
}

.alert-line {
  width:15.9vw;
  border-bottom:1px dashed  #ffb801;
  position: absolute;
  left:1.75vw;
  top:8.6vh;
  z-index: 5;
}
</style>
